module.exports = __webpack_public_path__ + "static/media/Palkia_gaussian2.d13761d1.png";